<template>
  <div class="width-content">
    <MaintenanceAlert v-if="hasMaintenanceStripe" />
    <div v-else>
      <!-- success page -->
      <div
        v-show="showSuccessPage"
        class="mx-auto success-page mt-3 mb-1"
      >
        <top-up-success
          :show-success-page.sync="showSuccessPage"
          :payment-method="PAYMENT_METHOD.CREDITCARD"
          @handle-recharge-credit-card="showSuccessPage = false"
        />
      </div>
      <!-- /end success page -->

      <!--    warning message-->
      <div
        v-if="isShowWarningAddCard"
        :class="hasStepGuide ? 'warning-has-step' : ''"
      >
        <div class="warning-message">
          <div class="d-flex align-items-center mb-1">
            <img
              class="alert-img mr-50"
              alt="alert"
              :src="require('@/assets/images/common/ic-alert.svg')"
            >
            <h3 class="mb-0">
              {{ $t('addFundPage.titleWarningReAddCard') }}
            </h3>
          </div>
          <p>
            {{ $t('addFundPage.contentWarningReAddCard') }}
          </p>
          <p class="font-14">
            {{ $t('addFundPage.subWarningReAddCard') }}
          </p>
          <user-hint class="font-14" />
        </div>
      </div>
      <!--    warning message-->

      <b-row
        v-show="!showSuccessPage"
        class="add-fund-container width-content"
      >
        <b-col
          :md="hasStepGuide ? 12 : 9"
          class="px-0 card-content"
        >
          <div class="">
            <div
              class="d-flex flex-column list-card list-credit-card position-relative"
              @mouseover="showGuideDefault = false"
              @mouseleave="showGuideDefault = true"
            >
              <div
                class="text-placeholder list-card bg-white px-0"
                :class="hasStepGuide ? 'radius-content' : ''"
              >
                <div
                  v-if="!hasStepGuide"
                  class="text-dark mx-2 mt-3 mt-lg-2"
                >
                  <h4>{{ $t('balance.textCreditCard') }}</h4>
                </div>

                <div
                  class="list-content-card"
                  :class="hasStepGuide ? 'py-2 mt-4 mt-lg-2' : ''"
                >
                  <div
                    v-if="!hasStepGuide"
                    class="list-header"
                  >
                    <b-row class="mx-2 my-1">
                      <b-col
                        cols="12"
                        md="3"
                        class="pl-0"
                      >
                        {{ $t('addFundPage.creditCardPayment.testMyCreditCards') }}
                      </b-col>
                      <b-col
                        cols="6"
                        md="3"
                        class="d-none d-md-block"
                      >
                        {{ $t('addFundPage.creditCardPayment.textCardID') }}
                      </b-col>
                      <b-col
                        cols="6"
                        md="6"
                        class="d-none d-md-block"
                      >
                        {{ $t('account.status') }}
                      </b-col>
                    </b-row>
                    <hr class="hr-custom">
                  </div>
                  <div
                    class="list-body"
                    :class="{ 'pa-1': loading && listCard.length === 0 }"
                  >
                    <b-overlay
                      :show="showOverLay"
                      spinner-small
                      opacity=".3"
                      blur="blur"
                      rounded="sm"
                    >
                      <div
                        v-if="listCard.length > 0"
                        id="list-card"
                        data-testid="list-card"
                      >
                        <credit-card-item
                          v-for="(item, index) in listCard"
                          :key="index"
                          :id="`card-item-${index+1}`"
                          :card="item"
                          :index="index"
                          :is-active="item.default"
                          :has-only-one-card="!!(listCard.length === 1)"
                          @chooseCard="chooseCard"
                          @deleteCard="deleteCard"
                          @initCard="initCardPayment"
                          @cancelTrial="cancelTrial"
                          @openActiveCardModal="openActiveCardModal"
                        />
                      </div>
                      <div
                        v-else
                        class="text-center my-2"
                      >
                        <img
                          :src="
                            require('@/assets/images/common/no-credit-card-found.png')
                          "
                          alt="image"
                          class="img-not-found mb-1"
                        >
                        <p>{{ $t('addFundPage.creditCardPayment.textNoCreditCard') }}</p>
                      </div>
                      <!-- <hr :class="{ 'hr-no-margin': listCard.length > 0 }"> -->
                    </b-overlay>
                  </div>

                  <!-- done step -->
                  <div
                    v-if="!hasStepGuide"
                    class="list-footer"
                  >
                    <hr class="hr-custom">
                    <b-row class="mx-2 my-1">
                      <b-col
                        cols="12"
                        class="text-center cursor-pointer"
                        @click="toggleAddNewCard"
                      >
                        <div
                          :id="`btn-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                          :data-testid="`btn-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                          class="d-flex align-items-center justify-content-center"
                        >
                          <feather-icon
                            :id="`icon-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                            :data-testid="`icon-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                            size="20"
                            class="btn-add-icon"
                            :icon="showAddNewCard ? 'MinusIcon' : 'PlusIcon'"
                          />
                          <span
                            :id="`text-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                            :data-testid="`text-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                            class="btn-add"
                          >{{
                            showAddNewCard ? $t('common.btnClose') : $t('addFundPage.creditCardPayment.textAddCreditCard')
                          }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <!-- done step -->
                </div>

                <div
                  v-if="errorStripe"
                  class="error-message-stripe"
                >
                  <error-tag :error="errorStripe || ''" />
                </div>

                <!-- has step guide -->
                <div class="list-footer">
                  <b-row
                    v-if="hasStepGuide"
                    class="mx-2 my-1"
                  >
                    <b-col
                      cols="12"
                      class="text-center cursor-pointer"
                      @click="toggleAddNewCard"
                    >
                      <div
                        :id="`btn-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                        :data-testid="`btn-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                        class="d-flex align-items-center justify-content-center"
                      >
                        <feather-icon
                          :id="`icon-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                          :data-testid="`icon-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                          size="20"
                          class="btn-add-icon"
                          :icon="showAddNewCard ? 'MinusIcon' : 'PlusIcon'"
                        />
                        <span
                          :id="`text-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                          :data-testid="`text-${showAddNewCard ? 'close' : 'add-credit-card'}`"
                          class="btn-add"
                        >{{
                          showAddNewCard ? $t('common.btnClose') : $t('addFundPage.creditCardPayment.textAddCreditCard')
                        }}</span>
                      </div>
                    </b-col>
                  </b-row>
                  <div class="d-flex pb-2 px-2 mt-2">
                    <img
                      v-for="(url, i) in brandLogo"
                      :key="i"
                      :src="url"
                      alt="brand"
                      style="margin-right: 5px"
                      :style="{ width: i === brandLogo.length - 1 ? '58px' : '33px' }"
                    >
                    <p class="font-14 mb-0 text-right text-md-left">
                      {{ $t('payment.textGuaranteed') }} <span class="text-success font-medium">{{ $t('payment.textSafe') }}</span>
                      {{ $t('payment.textCheckout') }}
                    </p>
                  </div>
                </div>
                <!-- end has step guide -->
              </div>
            </div>
            <!-- List Credit Card -->

            <div
              class="my-1 credit-form px-0"
              :class="{ 'my-2': showAddNewCard }"
            >
              <credit-card-form
                v-if="stripeElements"
                :card-data="card"
                :card-cvc-error="cardCvcError"
                :card-expiry-error="cardExpiryError"
                :card-number-error="cardNumberError"
                :card-name-error="cardNameError"
                :card-email-error="cardEmailError"
                :save-card-loading="saveCardLoading"
                :show-add-new-card="showAddNewCard"
                :save-card-error="saveCardError"
                @change-name="onChangeName"
                @change-email="onChangeEmail"
                @save-card="saveCard"
                @focus-email="onFocusEmail"
              />
              <warning-notification
                v-else
              >
                <template #title>
                  <div class="d-flex">
                    <img
                      class="alert-img mr-50"
                      alt="alert"
                      width="15"
                      :src="require('@/assets/images/common/ic-alert.svg')"
                    >
                    <p class="font-weight-bold mb-0">
                      {{ $t('payment.creditCard.textAddNewCardUnavailable') }}
                    </p>
                  </div>
                </template>
              </warning-notification>
            </div>
            <!-- Add Credit Card -->
            <div
              v-if="listCard.length > 0 && checkHasActiveCard"
              class="top-up-form"
              @mouseover="showGuideDefault = false"
              @mouseleave="showGuideDefault = true"
            >
              <div class="list-card bg-white credit-card-top-up-form position-relative">
                <top-up-form
                  ref="top-up-form"
                  :user-data="user"
                  :re-charge-loading="reChargeLoading"
                  :error-recharge="errorRecharge"
                  :error-topup="errorTopup"
                  @recharge="reCharge"
                />
              </div>
            </div>
            <div
              v-if="false"
              :offset="$device.mobile ? 0 : 3"
            >
              <div class="warning-message d-flex align-items-center">
                <img
                  style="margin-right: 8px"
                  alt="alert"
                  :src="require('@/assets/images/common/ic-alert.svg')"
                >
                <small>
                  {{ $t('payment.creditCard.textCreditCardWillBeActive') }}
                </small>
              </div>
            </div>
            <!-- TopUp Form -->

            <user-hint :class="showUserGuide ? 'd-lg-none' : ''" />
          </div>
        </b-col>
        <b-col
          v-if="!hasStepGuide"
          cols="12"
          md="9"
          :lg="hasStepGuide ? 12 : 3"
          class="payment-user-guide card-content"
        >
          <user-guide v-if="showUserGuide" />
        </b-col>
      </b-row>

      <!-- Modal verify code -->
      <verify-code-modal
        ref="modal-code"
        :init-card-loading="initCardLoading"
        :error-resent-code="errorResentCode"
        :error-code="errorCode"
        :time-count-down="timeCountDown"
        @resendCode="resendCode"
        @resetError="resetError"
        @resetErrorCode="resetErrorCode"
      />
      <!-- Modal verify code -->
    </div>
  </div>
</template>
<script>
/* eslint-disable global-require */

import {
  BRow, BCol, BOverlay,
} from 'bootstrap-vue'
import { createNamespacedHelpers } from 'vuex'
import { PaymentService } from '@/services'
import { toastification } from '@core/mixins/toast'
import paymentMixin from '@/mixins/paymentMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import { getResponse } from '@/plugins/store'
import { PAYMENT_METHOD, TRANSACTION_TYPE, PAYMENT_GATE_STATUS } from '@/constants'
import _find from 'lodash/find'
import axios from '@axios'
import _get from 'lodash/get'
import envMixin from '@/mixins/envMixin'
import Vue from 'vue'
import { StripePlugin } from '@vue-stripe/vue-stripe'
import authMixin from '@/mixins/authMixin'
import gaTrackingMixin from '@/mixins/gaTrackingMixin'
import UserHint from '@/components/UserHint.vue'
import errorTag from '@/components/errorTag.vue'
import UserGuide from '@/components/UserGuide.vue'
import WarningNotification from '@/views/home/components/WarningNotification.vue'
import CreditCardItem from './CreditCardItem.vue'
import CreditCardForm from './CreditCardForm.vue'
import TopUpForm from './TopUpForm.vue'
import TopUpSuccess from './TopUpSuccess.vue'
import VerifyCodeModal from './VerifyCodeModal.vue'
import MaintenanceAlert from '../MaintenanceAlert.vue'

const {
  mapMutations,
  mapGetters,
  mapActions,
} = createNamespacedHelpers('payment')
const {
  mapGetters: mapGettersAuth,
  mapActions: mapActionsAuth,
} = createNamespacedHelpers('auth')
const {
  mapGetters: mapGettersBilling,
  mapActions: mapActionsBilling,
} = createNamespacedHelpers('billing')

export default {
  components: {
    WarningNotification,
    errorTag,
    VerifyCodeModal,
    TopUpSuccess,
    TopUpForm,
    CreditCardForm,
    CreditCardItem,
    UserHint,
    UserGuide,
    BRow,
    BCol,
    BOverlay,
    MaintenanceAlert,
  },
  mixins: [toastification, paymentMixin, envMixin, stepGuideMixin, authMixin, gaTrackingMixin, authMixin],
  data() {
    return {
      // card element
      card: {
        cvc: '',
        number: '',
        expiry: '',
        email: '',
        name: '',
      },

      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,

      // card errors
      cardCvcError: '',
      cardExpiryError: '',
      cardNumberError: '',
      cardNameError: '',
      cardEmailError: '',

      showAddNewCard: false,
      showSuccessPage: false,

      // loading
      saveCardLoading: false,
      setCardDefaultLoading: false,
      reChargeLoading: false,
      deleteCardLoading: false,
      initCardLoading: false,
      cancelTrialLoading: false,
      stripeElements: null,
      errorRecharge: '',

      errorStripe: '',
      errorTopup: '',
      saveCardError: '',
      errorResentCode: '',
      errorCode: '',

      // brand logo
      brandLogo: [
        require('@/assets/images/pages/payment/ic-visacard.svg'),
        require('@/assets/images/pages/payment/ic-mastercard.svg'),
        require('@/assets/images/pages/payment/ic-amexcard.svg'),
        require('@/assets/images/pages/payment/ic-discovercard.svg'),
      ],

      // const
      PAYMENT_METHOD,

      showGuideDefault: true,
      contentModal: {},
      creditCardPaymentModal: {
        title: 'How to add fund with Credit Card?',
        description: '',
        video: 'https://www.youtube.com/embed/JVWEtr_K1Ik',
        guideURL: process.env.VUE_APP_GUIDE_TO_TOP_UP_CREDIT_CARD,
      },
      creditCardPaymentModalNoStep: {
        title: 'How to add fund with Credit Card?',
        description: '',
        video: 'https://www.youtube.com/embed/dT0TRIx9oSY',
        guideURL: process.env.VUE_APP_GUIDE_TO_TOP_UP_CREDIT_CARD,
      },

      timeCountDown: {},
    }
  },
  computed: {
    ...mapGetters(['listCard', 'loading', 'status', 'message']),
    ...mapGettersBilling(['subscriptionStatus']),
    ...mapGettersAuth(['user']),

    // stripeElements() {
    //   return this.$stripe.elements()
    // },

    needToAddCardToStripeUS() {
      return _get(this.user, ['data', 'needToAddCardToStripeUS'])
    },

    isShowWarningAddCard() {
      return this.needToAddCardToStripeUS
    },

    checkFormValid() {
      return !!(
        this.card.number
        && this.card.expiry
        && this.card.cvc
        && this.card.email
        && this.card.name
        && this.cardNumberError === ''
        && this.cardExpiryError === ''
        && this.cardCvcError === ''
        && this.cardEmailError === ''
        && this.cardNameError === ''
      )
    },

    showOverLay() {
      return (
        this.setCardDefaultLoading
        || this.loading
        || this.deleteCardLoading
        || this.initCardLoading
        || this.cancelTrialLoading
      )
    },

    checkHasActiveCard() {
      let hasActiveCard = false
      if (this.listCard?.length > 0) {
        const obj = _find(this.listCard, { default: true })
        if (obj?.verifiedAt) {
          hasActiveCard = true
        }
      }
      return hasActiveCard
    },

    fullName() {
      return _get(this.user, ['data', 'fullName'], '')
    },

    email() {
      return _get(this.user, ['data', 'email'], '')
    },

    hasMaintenanceStripe() {
      return this.paymentInfo?.creditCard?.status === PAYMENT_GATE_STATUS.MAINTENANCE
    },
  },

  watch: {
    user: {
      async handler(currentUser) {
        const locale = localStorage.getItem('locale') || process.env.VUE_APP_LOCALE
        const pk = currentUser?.data?.billings?.stripe?.stripe_pk
        if (!pk) return

        const options = {
          pk,
          locale,
        }
        await Vue.use(StripePlugin, options)
        this.stripeElements = this.$stripe.elements()
        this.initFormElement()
      },
      deep: true,
      immediate: true,
    },

    errorTopup: {
      handler(error) {
        if (error) {
          window.scrollTo(0, document.body.scrollHeight)
        }
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.getListCard()
    // this.initFormElement()
  },

  beforeDestroy() {
    if (this.stripeElements) {
      this.cardNumber.destroy()
      this.cardExpiry.destroy()
      this.cardCvc.destroy()
    }
  },

  methods: {
    ...mapActions(['getListCard', 'getHistoryLimit']),
    ...mapActionsAuth(['getAccountInfo', 'getGeneralConfig']),
    ...mapMutations(['SET_CARD_DEFAULT']),
    ...mapActionsBilling(['getSubscriptionStatus']),

    initFormElement() {
      const style = {
        base: {
          color: '#16213E',
          lineHeight: '44px',
          fontWeight: 300,
          fontFamily: 'Mulish, sans-serif',
          fontSize: '16px',
          '::placeholder': {
            color: '#B9B9C3',
            fontSize: '16px',
          },
          invalid: {
            iconColor: '#E11C4E',
            color: '#E11C4E',
          },
        },
      }

      this.$nextTick(() => {
        this.cardNumber = this.stripeElements.create('cardNumber', {
          style,
        })
        this.cardNumber.mount('#card-number')

        this.cardExpiry = this.stripeElements.create('cardExpiry', {
          style,
        })
        this.cardExpiry.mount('#card-expiry')

        this.cardCvc = this.stripeElements.create('cardCvc', {
          style,
        })
        this.cardCvc.mount('#card-cvc')

        this.listenForErrors()
      })
    },

    listenForErrors() {
      this.cardNumber.addEventListener('change', event => {
        this.cardNumberError = ''
        this.toggleError(event, 'cardNumber')
        this.card.number = !!event.complete
      })

      this.cardExpiry.addEventListener('change', event => {
        this.cardExpiryError = ''
        this.toggleError(event, 'cardExpiry')
        this.card.expiry = !!event.complete
      })

      this.cardCvc.addEventListener('change', event => {
        this.cardCvcError = ''
        this.toggleError(event, 'cardCvc')
        this.card.cvc = !!event.complete
      })
    },

    toggleError(event, type) {
      if (event.error) {
        switch (type) {
          case 'cardNumber':
            this.cardNumberError = event.error.message
            break
          case 'cardExpiry':
            this.cardExpiryError = event.error.message
            break
          case 'cardCvc':
            this.cardCvcError = event.error.message
            break
          default:
            break
        }
      }
    },

    checkEmailValid(type) {
      const { email } = this.card
      const mailFormat = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/
      if (type !== 'onChange') {
        if (!email) {
          this.cardEmailError = this.$t('payment.creditCard.errorMailIncomplete')
        } else if (!email.match(mailFormat)) {
          this.cardEmailError = this.$t('payment.creditCard.errorMailInvalid')
        }
      } else if (!email.match(mailFormat)) {
        this.cardEmailError = this.$t('payment.creditCard.errorMailInvalid')
      }
    },

    checkNameValid() {
      const { name } = this.card
      if (!name) {
        this.cardNameError = this.$t('payment.creditCard.errorNameIncomplete')
      }
    },

    onChangeEmail(value) {
      this.cardEmailError = ''
      this.card.email = value
      if (value) {
        this.checkEmailValid('onChange')
      }
    },

    onFocusEmail() {
      this.cardEmailError = ''
    },

    onChangeName(value) {
      const validate = / {2,}/
      this.cardNameError = ''
      this.card.name = value
      if (validate.test(value)) {
        this.cardNameError = this.$t('payment.creditCard.errorNameCardInvalid')
      }
    },

    async chooseCard(card) {
      try {
        this.setCardDefaultLoading = true
        this.resetError()
        await PaymentService.setCardDefault(card)
        this.SET_CARD_DEFAULT(card)
        this.setCardDefaultLoading = false
      } catch (e) {
        this.setCardDefaultLoading = false
        // this.toastFailure(e.data.message || 'Set card default error!')
        this.errorStripe = e.data.message || this.$t('payment.creditCard.errorSetCardFail')
      }
    },

    async deleteCard(id) {
      this.deleteCardLoading = true
      this.resetError()
      try {
        await PaymentService.deleteCard(id)
        this.deleteCardLoading = false
        this.getListCard()
        this.toastSuccess(this.$t('payment.creditCard.toastRemoveCardSuccess'))
      } catch (e) {
        this.deleteCardLoading = false
        // this.toastFailure(e.data.message || 'Delete Card Failure!')
        this.errorStripe = e.data.message || this.$t('payment.creditCard.toastRemoveCardFail')
      }
    },

    async saveCard() {
      this.resetError()

      if (!this.checkFormValid) {
        // Validate form manually
        if (!this.card.number && !this.cardNumberError) {
          this.cardNumberError = this.$t('payment.creditCard.errorCardNumberIncomplete')
        } else if (!this.cardNumberError) {
          this.cardNumberError = ''
        }

        if (!this.card.expiry && !this.cardExpiryError) {
          this.cardExpiryError = this.$t('payment.creditCard.errorCardExpiredIncomplete')
        } else if (!this.cardExpiryError) {
          this.cardExpiryError = ''
        }

        if (!this.card.cvc && !this.cardCvcError) {
          this.cardCvcError = this.$t('payment.creditCard.errorCardSecurityIncomplete')
        } else if (!this.cardCvcError) {
          this.cardCvcError = ''
        }

        this.checkEmailValid('onSubmit')
        this.checkNameValid()
      } else {
        this.saveCardLoading = true

        try {
          const { data } = await PaymentService.setUpIntent()
          const {
            name,
            email,
          } = this.card
          const resultConfirm = await this.$stripe.confirmCardSetup(
            getResponse(data).clientSecret,
            {
              payment_method: {
                card: this.cardNumber,
                billing_details: {
                  email,
                  name,
                },
              },
            },
          )

          if (resultConfirm.error) {
            this.saveCardLoading = false
            // this.toastFailure(resultConfirm.error.message || 'Serve error!')
            this.saveCardError = resultConfirm.error.message || this.$t('payment.creditCard.toastServeError')
          } else {
            try {
              const dataToPost = {
                paymentMethodId: resultConfirm.setupIntent.payment_method,
                setupIntentClientSecret: getResponse(data).clientSecret,
                default: true,
              }

              await PaymentService.saveCard(dataToPost)
              this.saveCardLoading = false
              this.resetAddNewCardForm()
              this.closeAddNewCard()
              this.getListCard()
            } catch (e) {
              this.saveCardLoading = false
              // this.toastFailure(e?.data?.message || 'Save card error')
              this.saveCardError = e.data.message || this.$t('payment.creditCard.toastSaveCardFail')
            }
          }
        } catch (e) {
          this.saveCardLoading = false
          // this.toastFailure(e?.data?.message || 'Save card error')
          this.saveCardError = e.data.message || this.$t('payment.creditCard.toastSaveCardFail')
        }
      }
    },

    async cancelTrial(idCardPayment) {
      this.resetError()
      try {
        this.cancelTrialLoading = true
        await this.getSubscriptionStatus()
        const { id } = this.subscriptionStatus
        await axios.put(`/api/stripe-payment/subscriptions/${id}/cancel`)
        await this.deleteCard(idCardPayment)
        this.cancelTrialLoading = false
        this.getAccountInfo() // update plansStatus again
        this.getSubscriptionStatus() // update current subscription again to show alert confirm payment or not
      } catch (e) {
        this.cancelTrialLoading = false
        // this.toastFailure(e.data.message || 'Cancel Subscription Failure!')
        this.errorStripe = e.data.message || this.$t('payment.creditCard.toastCancelSubscriptionFail')
      }
    },

    resetAddNewCardForm() {
      this.cardNumber.clear()
      this.cardExpiry.clear()
      this.cardCvc.clear()
      this.card.email = ''
      this.card.name = ''
      this.resetError()
    },

    async reCharge(params) {
      this.reChargeLoading = true
      this.errorRecharge = ''
      this.resetError()
      try {
        const { data } = await PaymentService.reCharge(params)
        if (this.isOnlyEcomdyPlatform) {
          this.gaTrackingUserAddFund(params.amount, PAYMENT_METHOD.CREDITCARD) // GA Tracking
        }
        const {
          status,
          clientSecret,
          paymentMethod,
        } = getResponse(data)

        if (status === 'succeeded') {
          this.handleSuccess()
        }
        if (status === 'requires_action') {
          this.confirmPayment(clientSecret, paymentMethod)
        }
      } catch (e) {
        this.reChargeLoading = false
        if (e.data?.code === 'error.cant_recharge_ads_account_when_toggle_selected') {
          this.errorRecharge = e.data?.message
        } else if (e.data?.code === 'error.user_was_blocked') {
          window.location.href = '/user-block'
        } else {
          // this.toastFailure(e.data?.message)
          this.errorTopup = e.data?.message
        }
      }
    },

    async confirmPayment(clientSecret, defaultPaymentMethod) {
      this.resetError()
      try {
        const resultConfirm = await this.$stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: defaultPaymentMethod,
          },
        )

        if (resultConfirm.error) {
          this.reChargeLoading = false
          // this.toastFailure(
          //   resultConfirm.error.message || 'Confirm payment failure!',
          // )
          this.errorTopup = resultConfirm.error.message || this.$t('payment.creditCard.toastConfirmPaymentFail')
          return
        }

        const { status } = resultConfirm.paymentIntent

        if (status === 'succeeded') {
          await PaymentService.fulFill({
            paymentIntentId: resultConfirm.paymentIntent.id,
          })
          this.handleSuccess()
        }
      } catch (e) {
        this.reChargeLoading = false
        if (e.data?.code === 'error.cant_recharge_ads_account_when_toggle_selected') {
          this.errorRecharge = e.data?.message
        } else {
          // this.toastFailure(e.data?.message || e.message)
          this.errorTopup = e.data?.message || e.message
        }
      }
    },

    async handleSuccess() {
      this.resetError()
      this.fetchHistory()
      this.getGeneralConfig()
      this.getAccountInfo() // for date user balance
      this.reChargeLoading = false
      await this.$refs['top-up-form'].sendInvoice() // send data to success page.
      this.$refs['top-up-form'].resetForm() // reset top up form
      this.toastSuccess(this.hasStepGuide && this.isSetupCostModel ? this.$t('payment.toastSetupCostSuccess') : this.$t('payment.toastTopUpSuccess'))
      if (this.hasStepGuide) {
        if (this.isOnlyEcomdyPlatform) {
          this.gaTrackingUserStep(this.setupGuideStep) // GA Tracking
        }
        this.$router.push({ name: 'my-ads-account' })
      } else {
        this.showSuccessPage = true

        this.$emit('handleShowSuccessTabs', this.showSuccessPage)
      }
    },

    toggleAddNewCard() {
      this.showAddNewCard = !this.showAddNewCard
    },

    closeAddNewCard() {
      this.showAddNewCard = false
    },

    openActiveCardModal() {
      this.$refs['modal-code'].showModal()
    },

    async initCardPayment(type) {
      this.resetError()
      try {
        this.initCardLoading = true
        const { data } = await PaymentService.initCard()

        const {
          status,
          clientSecret,
          paymentMethod,
        } = getResponse(data)

        if (status === 'succeeded') {
          if (type !== 'resend') {
            this.$refs['modal-code'].showModal()
          } else {
            this.toastSuccess(this.$t('payment.creditCard.toastSendCodeSuccess'))
          }
          this.initCardLoading = false
          this.getAccountInfo() // update user balance when get active code successfully
        }
        if (status === 'requires_action') {
          this.confirmInitCard(clientSecret, paymentMethod, type)
          this.getAccountInfo() // update user balance when get active code successfully
        }
      } catch (e) {
        this.initCardLoading = false
        if (e?.data?.status === 429) {
          this.toastFailure(
            this.$t('payment.creditCard.toastTooManyFail'),
          )
        } else if (type === 'resend') {
          this.errorResentCode = e?.data?.message
          this.errorCode = e?.data?.code
          this.timeCountDown = e?.data?.args
        } else {
          this.errorStripe = e?.data?.message
        }
      }
    },

    async confirmInitCard(clientSecret, defaultPaymentMethod, type) {
      this.resetError()
      try {
        const resultConfirm = await this.$stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: defaultPaymentMethod,
          },
        )

        if (resultConfirm.error) {
          this.initCardLoading = false
          // this.toastFailure(
          //     resultConfirm?.error?.message || 'Init card failure!',
          // )
          if (type === 'resend') {
            this.errorResentCode = resultConfirm?.error?.message
            this.errorCode = resultConfirm?.error?.code
            this.timeCountDown = resultConfirm?.error?.args
          } else {
            this.errorStripe = resultConfirm?.error?.message || this.$t('payment.creditCard.toastInitCardFail')
          }

          return
        }

        const { status } = resultConfirm.paymentIntent

        if (status === 'succeeded') {
          if (type !== 'resend') {
            // this.$refs['modal-code'].showModal()
            this.toastSuccess(this.$t('payment.creditCard.toastSendCodeSuccess'))
          } else {
            this.toastSuccess(this.$t('payment.creditCard.toastSendCodeSuccess'))
          }
          this.initCardLoading = false
          await PaymentService.fulFill({
            paymentIntentId: resultConfirm.paymentIntent.id,
          })
        }
      } catch (e) {
        this.initCardLoading = false
        // this.toastFailure(e.message)
        if (type === 'resend') {
          this.errorResentCode = e.message
          this.errorCode = e?.code
          this.timeCountDown = e?.args
        } else {
          this.errorStripe = e.message
        }
      }
    },

    resendCode() {
      this.resetError()
      this.initCardPayment('resend')
    },

    async fetchHistory() {
      this.resetError()
      const params = {
        page: 1,
        size: 1,
        types: [
          TRANSACTION_TYPE.RECHARGE_USER_BALANCE,
          TRANSACTION_TYPE.ADMIN_FIX_RECHARGE_MONEY,
          TRANSACTION_TYPE.SETUP_COST,
        ],
      }
      await this.getHistoryLimit(params)
    },

    goToCCGuide() {
      window.open(process.env.VUE_APP_GUIDE_TO_TOP_UP_CREDIT_CARD)
    },

    resetError() {
      this.errorStripe = ''
      this.errorTopup = ''
      this.saveCardError = ''
      this.errorResentCode = ''
    },

    resetErrorCode() {
      this.errorCode = ''
    },

    openLiveChat() {
      if (window.fcWidget) {
        window.fcWidget.open()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.radius-content {
  border-radius: 0px 0px var(--border-radius-base) var(--border-radius-base) !important;
}

.list-card {
  border-radius: var(--border-radius-base);
  // max-width: 864px;

  .hr-custom {
    border-top: 1px solid rgba(22, 33, 62, 0.1);
  }
}

.list-content-card {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: var(--border-radius-base);
  margin: 24px;
}

.error-message-stripe {
  margin: 0 24px;
}

.list-body {
  .hr-custom {
    margin-top: 0;
  }
}

.credit-form {
  border-radius: var(--border-radius-base);
  margin: 1.5rem 3%;

  @media(max-width: 767px) {
    margin: 1.5rem 0px;
  }
}

.success-page {
  max-width: 380px;
}

.pa-1 {
  padding-bottom: 1px;
}

.img-not-found {
  width: 70px;
}

.warning-message {
  max-width: 837px;
  margin-top: 10px;
  background: rgba(251, 176, 59, 0.1);
  border-radius: 10px;
  padding: 10px 12px 10px 16px;
}

.btn-add {
  margin-left: 5px;
  color: $primary;
}

.btn-add-icon {
  color: $primary;
}

.width-content {
  max-width: 1200px;
  margin: 0px auto;

  @media (max-width: 992px) {
    justify-content: center;
  }
}

.guide-video {
  position: absolute;
  top: 19px;
  left: 20px;
  color: #4CB375;
}

.guide-icon {
  top: 19px;
  right: 12px;
}

.list-credit-card:hover .tooltip-list-credit-card {
  @media (min-width: 992px) {
    display: block;
  }
}

.credit-card-top-up-form:hover .tooltip-credit-card-top-up-form {
  @media (min-width: 992px) {
    display: block;
  }
}

.warning-has-step {
  background-color: #fff;
  padding: 24px 24px 0 24px;

  .warning-message {
    margin: 0;
  }
}

.warning-message {
  background: rgba(251, 176, 59, 0.1);
  border-radius: var(--border-radius-base);
  padding: 16px;
  max-width: 900px;
  margin-bottom: 2rem;
}
</style>
